import React from 'react';
import { classnames } from '../../../../utils/classnames';
import PropTypes from 'prop-types';

import { ReactComponent as Arrow } from '../../../../picture/arrow.svg';
import { ReactComponent as ArrowLeft } from '../../../../picture/chevron-left.svg';
import { ReactComponent as ArrowRight } from '../../../../picture/chevron-right.svg';
import { ReactComponent as BuildingHouse } from '../../../../picture/building-house.svg';
import { ReactComponent as Calendar } from '../../../../picture/calendar.svg';
import { ReactComponent as Check } from '../../../../picture/check-green.svg';
import { ReactComponent as Download } from '../../../../picture/download.svg';
import { ReactComponent as ExclamationBlue } from '../../../../picture/exclamation-blue.svg';
import { ReactComponent as ExclamationRed } from '../../../../picture/exclamation-red.svg';
import { ReactComponent as ExclamationYellow } from '../../../../picture/exclamation-yellow.svg';
import { ReactComponent as ExternalLink } from '../../../../picture/link-external.svg';
import { ReactComponent as Globe } from '../../../../picture/globe.svg';
import { ReactComponent as InfoCircle } from '../../../../picture/info-circle.svg';
import { ReactComponent as LinkFolder } from '../../../../picture/link-folder.svg';
import { ReactComponent as Lock } from '../../../../picture/lock.svg';
import { ReactComponent as MailSend } from '../../../../picture/mail-send.svg';
import { ReactComponent as MapPin } from '../../../../picture/map-pin.svg';
import { ReactComponent as Minus } from '../../../../picture/minus-white.svg';
import { ReactComponent as Plus } from '../../../../picture/plus-white.svg';
import { ReactComponent as QR } from '../../../../picture/qr.svg';
import { ReactComponent as Refresh } from '../../../../picture/refresh.svg';
import { ReactComponent as SubGroup } from '../../../../picture/subdirectory-right.svg';
import { ReactComponent as Ticket } from '../../../../picture/Ticket.svg';
import { ReactComponent as Timer } from '../../../../picture/timer.svg';
import { ReactComponent as Upload } from '../../../../picture/upload.svg';
import { ReactComponent as UserCircle } from '../../../../picture/User-circle.svg';
import { ReactComponent as CheckSimple } from '../../../../picture/check-simple.svg';
import { ReactComponent as Cross } from '../../../../picture/cross-close.svg';
import { ReactComponent as Receipt } from '../../../../picture/receipt.svg';
import { ReactComponent as Reset } from '../../../../picture/reset.svg';
import { ReactComponent as RotateLeft } from '../../../../picture/rotate-left.svg';
import { ReactComponent as RotateRight } from '../../../../picture/rotate-right.svg';
import { ReactComponent as Search } from '../../../../picture/search.svg';
import { ReactComponent as ZoomIn } from '../../../../picture/zoom-in.svg';
import { ReactComponent as ZoomOut } from '../../../../picture/zoom-out.svg';
import { ReactComponent as Grid } from '../../../../picture/grid.svg';
import { ReactComponent as List } from '../../../../picture/list-ul.svg';
import { ReactComponent as LogOut } from '../../../../picture/log-out.svg';
import { ReactComponent as AppleWalletFR } from '../../../../picture/FR_apple_wallet.svg';
import { ReactComponent as AppleWalletEN } from '../../../../picture/EN_apple_wallet.svg';
import { ReactComponent as GoogleWalletFR } from '../../../../picture/FR_google_wallet.svg';
import { ReactComponent as GoogleWalletEN } from '../../../../picture/EN_google_wallet.svg';
import { ReactComponent as WhatsApp } from '../../../../picture/whatsapp.svg';
import { ReactComponent as Share } from '../../../../picture/share.svg';
import { ReactComponent as Telegram } from '../../../../picture/telegram.svg';
import { ReactComponent as Messenger } from '../../../../picture/messenger.svg';
import { ReactComponent as SMS } from '../../../../picture/sms.svg';
import { ReactComponent as PurchaseTag } from '../../../../picture/purchase-tag.svg';
import { ReactComponent as Edit } from '../../../../picture/Edit.svg';
import { ReactComponent as EditBlue } from '../../../../picture/edit-blue.svg';
import { ReactComponent as Rotate } from '../../../../picture/bx-rotate-left.svg';
import { ReactComponent as Cart } from '../../../../picture/cart.svg';
import { ReactComponent as Group } from '../../../../picture/group.svg';
import { ReactComponent as WalletPay} from '../../../../picture/wallet-pay.svg';
import { ReactComponent as PaperPlane} from '../../../../picture/paper-plane.svg';
import { ReactComponent as Time} from '../../../../picture/time.svg';
import { ReactComponent as Mobile} from '../../../../picture/mobile.svg';
import { ReactComponent as RedCross} from '../../../../picture/red-cross.svg';
import { ReactComponent as IdCard} from '../../../../picture/idCard.svg';
import { ReactComponent as Transfer} from '../../../../picture/transfer.svg';
import { ReactComponent as Copy} from '../../../../picture/copy.svg';


import './icon.css';
import { useTranslation } from 'react-i18next';

const MAPPING_ICON = {
    arrow: Arrow,
    arrowLeft: ArrowLeft,
    arrowRight: ArrowRight,
    building: BuildingHouse,
    calendar: Calendar,
    check: Check,
    download: Download,
    exclamationBlue: ExclamationBlue,
    exclamationRed: ExclamationRed,
    exclamationYellow: ExclamationYellow,
    externalLink: ExternalLink,
    globe: Globe,
    infoCircle: InfoCircle,
    linkfolder: LinkFolder,
    lock: Lock,
    mapPin: MapPin,
    minus: Minus,
    plus: Plus,
    qr: QR,
    refresh: Refresh,
    sendMail: MailSend,
    subGroup: SubGroup,
    ticket: Ticket,
    timer: Timer,
    upload: Upload,
    userCircle: UserCircle,
    checkSimple: CheckSimple,
    cross: Cross,
    receipt: Receipt,
    reset: Reset,
    rotateLeft: RotateLeft,
    rotateRight: RotateRight,
    search: Search,
    zoomIn: ZoomIn,
    zoomOut: ZoomOut,
    grid: Grid,
    list: List,
    logout: LogOut,
    frAppleWallet: AppleWalletFR,
    enAppleWallet: AppleWalletEN,
    frGoogleWallet: GoogleWalletFR,
    enGoogleWallet: GoogleWalletEN,
    whatsapp: WhatsApp,
    share: Share,
    telegram: Telegram,
    messenger: Messenger,
    sms: SMS,
    purchaseTag: PurchaseTag,
    edit: Edit,
    editBlue: EditBlue,
    rotate: Rotate,
    cart: Cart,
    group: Group,
    walletPay: WalletPay,
    paperPlane: PaperPlane,
    time: Time,
    mobile: Mobile,
    redCross: RedCross,
    idCard: IdCard,
    transfer: Transfer,
    copy: Copy
};

/**
 * This component provides a way to render an icon (from the available list) asynchronously (lazy).
 */
const Icon = ({ name, className, size = 'regular', onClick = undefined }) => {
    const { t, i18n } = useTranslation();
    const fallbackValue = <span />;

    if (!name) {
        return null;
    }

    return (
        <React.Suspense fallback={fallbackValue}>
            {Object.keys(MAPPING_ICON).includes(name)
                ? (
                    <div
                        className={classnames('neo-icon-wrapper', `neo-icon-wrapper-${size}`, className, {
                            'neo-icon-wrapper-clickable': onClick
                        })}
                        onClick={onClick}>
                        {React.createElement(MAPPING_ICON[name], {
                            className: 'neo-icon',
                            alt: i18n.exists(`widget.alt-icons.${name}`) ? t(`widget.alt-icons.${name}`) : 'icon',
                            'aria-label': '',
                            'aria-hidden': !Boolean(onClick)
                        })}
                    </div>
                ) : (
                    fallbackValue
                )}
        </React.Suspense>
    );
};

Icon.propTypes = {
    /**
     * The name of the icon to display, must exist in the list of the available icons.
     */
    name: PropTypes.oneOf(Object.keys(MAPPING_ICON)).isRequired,
    className: PropTypes.string,
    size: PropTypes.string,
    ariaHidden: PropTypes.oneOfType(PropTypes.bool, null),
};

Icon.defaultProps = {
    className: null,
    size: 'regular'
};

export default Icon;
